import './boostrap';
import { createApp } from 'vue';
export const app = createApp({});
// Plugins
import '@splidejs/splide/dist/css/splide.min.css';
import { VuePrlx } from "vue3-prlx";
app.use(VuePrlx);
// TypeScript
require('@/utils/core.ts');
require('@/utils/dom.ts');
require('@/utils/methods.ts');
// Wrappers - DO NOT DELETE
app.component('component-wrapper-module', require('@/components/wrapper').default);
app.component('smart-text', require('@/components/smart_text').default);
app.component('arrow-link', require('@/components/arrow_link').default);
app.component('badge', require('@/components/badge').default);
app.component('arrow', require('@/components/arrow').default);
app.component('image-split', require('@/modules/image_split').default);
app.component('big-text-breaker', require('@/modules/big_text_breaker').default);
app.component('main-text-block', require('@/modules/main_text_block').default);
app.component('image-carousel', require('@/modules/image_carousel').default);
app.component('article-list', require('@/modules/article_list').default);
app.component('article-item', require('@/modules/article_item').default);
app.component('casestudy-list', require('@/modules/casestudy_list').default);
app.component('floating-videos-with-sticky-text', require('@/modules/floating_videos_with_sticky_text').default);
app.component('article-content', require('@/modules/article_content').default);
app.component('cta-banner', require('@/modules/cta_banner').default);
app.component('team-listing', require('@/modules/team_listing').default);
app.component('default', require('@/modules/default').default);
app.component('career-listing', require('@/modules/career_listing').default);
app.component('article-carousel-item', require('@/modules/article_carousel_item').default);
// Video Ts
const video = require('./plugins/video');
document.addEventListener('DOMContentLoaded', function () {
    video.init();
});
app.mount('#app');
